module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.packagingPopupTitle')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('div', [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.packagingPopupTitle')))]), _vm._v(" "), (_vm.products.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px"
    },
    attrs: {
      "data": _vm.products,
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "vmp",
      "label": _vm.$t('form.products.vmp.label'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('form.products.name.label'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alcoholPercentage",
      "label": _vm.$t('form.products.alcoholPercentage.label')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bottleVolume",
      "label": _vm.$t('form.products.bottleVolume.label')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Packaging",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex"
        }, [_c('el-select', {
          attrs: {
            "placeholder": "Select Packaging"
          },
          on: {
            "change": function($event) {
              return _vm.onUpdatePackaging(scope.row)
            }
          },
          model: {
            value: (scope.row.productPackagingId),
            callback: function($$v) {
              _vm.$set(scope.row, "productPackagingId", $$v)
            },
            expression: "scope.row.productPackagingId"
          }
        }, _vm._l((_vm.productPackagings.all), function(packaging) {
          return (packaging.id) ? _c('el-option', {
            key: packaging.id,
            attrs: {
              "label": packaging.name,
              "value": packaging.id
            }
          }) : _vm._e()
        }), 1), _vm._v(" "), _c('el-button', {
          staticClass: "margin-l-10",
          attrs: {
            "type": "primary",
            "icon": "el-icon-plus",
            "circle": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addNewPackaging(scope.row)
            }
          }
        })], 1)]
      }
    }], null, false, 1525779534)
  })], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "small",
    attrs: {
      "disabled": !!_vm.hasProductWithNoPackaging,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirm($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.continue').toUpperCase()))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071d6607","hasScoped":false}!./src/app/components/vmpSyncPackagingPopup/vmpSyncPackagingPopup.html
// module id = 2899
// module chunks = 1